import { FileSpreadsheet, Printer } from "lucide-react";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import "./DayBook.css";
import axios from "axios";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";

const API_URL = "https://narrowitsolution.in/api";
const PAGE_LIMIT = 200;
const DayBook = () => {
  const [date, setDate] = useState("");
  const [appliedDate, setAppliedDate] = useState("");

  const [dayBookData, setDayBookData] = useState([]);
  const [totalDebit, setTotalDebit] = useState(0);
  const [totalCredit, setTotalCredit] = useState(0);

  const [maxLimit, setMaxLimit] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [hasSearched, setHasSearched] = useState(false);

    const { profile } = useSelector((state) => state.userProfile);
  const dispatch = useDispatch();

  // console.log("profile",profile)

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  /* ================= FETCH ================= */
  const fetchDayBookData = useCallback(async () => {
    if (!appliedDate) return;

    try {
      setLoading(true);
      setError("");

      const token = localStorage.getItem("authToken");

      const res = await axios.get(`${API_URL}/report/day-book`, {
        params: {
          superAdminId:profile?.superAdminId,
          branchId: profile?.branchId,
          date: appliedDate,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const vouchers = res?.data?.vouchers || [];
      // console.log("vouchers",res.data)

      setDayBookData(vouchers);
      setTotalDebit(res?.data?.totalDebit || 0);
      setTotalCredit(res?.data?.totalCredit || 0);

      setMaxLimit(Math.min(vouchers.length, PAGE_LIMIT));
      setCurrentPage(1);
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.message || "Failed to fetch day book")
      setError(err?.response?.data?.message || "Failed to fetch day book");
    } finally {
      setLoading(false);
    }
  }, [appliedDate,profile]);

  /* ================= FILTER ================= */
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!date) {
      toast.warn("Please select Date");
      return;
    }

    setAppliedDate(date);
    setHasSearched(true);
  };

  /* ================= FETCH AFTER SEARCH ================= */
  useEffect(() => {
    if (hasSearched) fetchDayBookData();
  }, [fetchDayBookData, hasSearched]);

  /* ================= PAGINATION ================= */
  const totalPages = Math.ceil(dayBookData.length / PAGE_LIMIT);

  const paginatedData = useMemo(() => {
    if (dayBookData.length <= PAGE_LIMIT) return dayBookData;

    const start = (currentPage - 1) * PAGE_LIMIT;
    const end = start + PAGE_LIMIT;
    return dayBookData.slice(start, end);
  }, [dayBookData, currentPage]);

  /* ================= HELPERS ================= */
  const splitEntries = (entries = []) => ({
    drEntries: entries.filter((e) => e.factor === "dr"),
    crEntries: entries.filter((e) => e.factor === "cr"),
  });

const remainingCount = Math.max(
  PAGE_LIMIT - dayBookData.length,
  0
);

  return (
    <>
      <div className="dayBook-container">
        <h1 className="dayBook-heading">Day Book</h1>

        {/* Overview Form Section */}
        <div className="dayBook-top">
          <form action="" className="dayBook-form" onSubmit={handleSubmit}>
            <div className="dayBook-form-section">
              <div className="dayBook-form-input-fields">
                 <label>Date</label>
              <input
                type="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
              />
              </div>
              {/* <div className="dayBook-form-input-fields">
                <label>Select Ledger</label>
                <select name="" id="">
                  <option value=""></option>
                </select>
              </div>
              <div className="dayBook-form-input-fields">
                <label>Select Voucher</label>
                <select name="" id="">
                  <option value="">Selecet Voucher</option>
                </select>
              </div>
              <div className="dayBook-form-input-fields">
                <label>Date</label>
                <input type="date" />
              </div>
              <div className="dayBook-form-input-fields">
                <label>Start Date</label>
                <input type="date" />
              </div>
              <div className="dayBook-form-input-fields">
                <label>End Date</label>
                <input type="date" />
              </div> */}
            </div>
            <div className="dayBook-form-submit-btn">
              <button type="submit">
              {loading ? "Loading..." : "Get Records"}
            </button>
            </div>
          </form>
        </div>

        {/* pdf download buttons */}
        <div className="dayBook-pdf-download-btns">
          <button>
            <FileSpreadsheet size={15} /> Download Excel
          </button>
          <button>
            <Printer size={15} /> Print
          </button>
        </div>

        <div className="dayBook-report-section">
          <h2>Ledgers</h2>

          <p className="dayBook-record-limit">
            MAXIMUM RECORDS SHOW LIMIT IS {PAGE_LIMIT} | REMAINING {remainingCount}
            </p>

          <div className="dayBook-report-table">
            <table>
              <thead>
                <tr>
                  <th>SN.</th>
                <th>Date</th>
                <th>Voucher No</th>
                <th>Voucher Type</th>
                <th>Narration</th>
                <th className="amount-head" style={{ width: "200px" }}>
                  <div className="dayBook-th-data">
                    <h4>Amount</h4>
                    <div className="dayBook-th-amount">
                      <span>DR</span>
                      <span>CR</span>
                    </div>
                  </div>
                </th>
                <th>Status</th>
                </tr>
              </thead>

              <tbody>
              {!hasSearched ? (
                <tr>
                  <td colSpan="7" style={{ textAlign: "center" }}>
                    Please select filters and click Get Records
                  </td>
                </tr>
              ) : paginatedData.length ? (
                paginatedData.map((item, index) => {
                  const { drEntries, crEntries } = splitEntries(item.entries);

                  return (
                    <tr key={item.id}>
                      <td>
                        {(currentPage - 1) * PAGE_LIMIT + index + 1}
                      </td>
                      <td>
                        {item.date
                          ? new Date(item.date).toLocaleDateString()
                          : "-"}
                      </td>
                      <td>{item.voucherNo}</td>
                      <td>{item.voucherType}</td>
                      <td>{item.narration}</td>

                      <td className="amount-row" style={{ width: "220px",border:"none"}}>
                        <span>
                          {drEntries.length
                            ? drEntries.map((e, i) => (
                                <div key={i}>{e.debit}</div>
                              ))
                            : "0"}
                        </span>
                        <span>
                          {crEntries.length
                            ? crEntries.map((e, i) => (
                                <div key={i}>{e.credit}</div>
                              ))
                            : "0"}
                        </span>
                      </td>

                      <td>{item.status || "-"}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="7" style={{ textAlign: "center" }}>
                    No results found
                  </td>
                </tr>
              )}

              {hasSearched && dayBookData.length > 0 && (
                <tr className="totalRow">
                  <td colSpan="5">TOTAL AMOUNT</td>
                  <td>
                    <div className="dayBook-th-amount" style={{ width: "200px" }}>
                      <p>{totalDebit}</p>
                      <p>{totalCredit}</p>
                    </div>
                  </td>
                  <td></td>
                </tr>
              )}
            </tbody>
            </table>

                      {/* PAGINATION (ONLY IF > 200) */}
          {dayBookData.length > PAGE_LIMIT && (
            <div className="pagination">
              <button
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((p) => p - 1)}
              >
                Prev
              </button>

              <span>
                Page {currentPage} of {totalPages}
              </span>

              <button
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage((p) => p + 1)}
              >
                Next
              </button>
            </div>
          )}

          {error && <p className="error-text">{error}</p>}
          </div>
        </div>
      </div>
    </>
  );
};

export default DayBook;
